import { ReactElement, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Header from 'containers/Header';
import FilterAudit from 'containers/filterAudit';
import Table from 'containers/Table';
import { createStructuredSelector } from 'reselect';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import {
  makeSelectMsgSubmit,
  makeSelectModalDraftType,
} from 'store/app/selectors';
import {
  setIsAuditar,
  setModalDraftType,
  setPracticaAuditoriaSeleccionada,
} from 'store/app/actions';
import { Redirect, useHistory } from 'react-router-dom';
import { RouteTypes } from 'consts';
import './practice-list.scss';
import { RfUiBreadcrumbs, RfUiModal } from 'renfe-components';
import { userProfile } from 'utils/profilesIndex';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import { makeSelectPracticasAuditoriaCount } from 'store/practicas/selectors';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  access_token: makeSelectTokenAccessToken(),
  msgSubmit: makeSelectMsgSubmit(),
  modalDraftType: makeSelectModalDraftType(),
  practicesAuditCount: makeSelectPracticasAuditoriaCount(),
} as any);

export const links = [
  {
    label: 'Auditar cuaderno',
    link: '#',
    textHelp: 'Auditar cuaderno',
    active: true,
  },
];

const options =
  '[{"label": "Fecha inicio de mayor a menor","value": {"order":"FECHA_INI_SERVICIO","ascDesc": "desc"},"active": "true"},{"label": "Fecha inicio de menor a mayor","value": {"order":"FECHA_INI_SERVICIO","ascDesc": "asc"},"active": "false"},{"label": "Fecha fin de mayor a menor","value": {"order":"FECHA_FIN_SERVICIO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de menor a mayor","value": {"order":"FECHA_FIN_SERVICIO","ascDesc": "asc"},"active": "false"}]';

const Audit = (): ReactElement => {
  const {
    access_token,
    msgSubmit,
    modalDraftType,
    profileActive,
    practicesAuditCount,
  } = useSelector<any, any>(selectors);
  const dispatch = useDispatch();
  const [list] = useState(false);
  const [checkedPractice] = useState<any[]>([]);
  const history = useHistory();

  if (
    profileActive?.ID_PERFIL === userProfile.alumno.extAspirante ||
    profileActive?.ID_PERFIL === userProfile.alumno.extBecario ||
    profileActive?.ID_PERFIL === userProfile.alumno.extMaquinista ||
    profileActive?.ID_PERFIL === userProfile.alumno.intBecario ||
    profileActive?.ID_PERFIL === userProfile.alumno.intMaquinista ||
    profileActive?.ID_PERFIL === userProfile.instructor
  ) {
    return <Redirect to={RouteTypes.HOME} push />;
  }

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  const redirect = (e: any) => {
    history.push(e.detail);
    dispatch(setIsAuditar('true'));
  };

  const handleSelectAll = (data) => {
    const newData = data.map((cell) => {
      return cell.data;
    });
    dispatch(setPracticaAuditoriaSeleccionada(newData.toString()));
  };

  const handleSelectPractica = (e: any) => {
    const practiceSelected: any = checkedPractice;
    if (e.detail.checked === true) {
      practiceSelected.push(e.detail.data);
    } else {
      const pos = practiceSelected.indexOf(e.detail.data);
      practiceSelected.splice(pos, 1);
    }
    dispatch(setPracticaAuditoriaSeleccionada(practiceSelected.toString()));
  };

  return (
    <>
      <Header />
      <div className="rf-layout-table rf-practice-list">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">Auditar Cuaderno</h1>
        <FilterAudit />
        <Table
          redirect={(e: any) => {
            redirect(e);
          }}
          list={list}
          itemsOnLeft={6}
          dataCount={practicesAuditCount}
          showButtonDetail={true}
          handleCheckAll={handleSelectAll}
          handleCheckPractica={handleSelectPractica}
          hideClaim={true}
          orderMobile={true}
          orderOptions={options}
        />

        <RfUiModal
          title-modal={msgSubmit}
          id-modal="modalDraft"
          modal-type={modalDraftType}
          onModalClose={(e: any) => {
            dispatch(setModalDraftType(''));
          }}
        ></RfUiModal>
      </div>
    </>
  );
};

export default Audit;
